// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"890a1252","561":"4cdeac1a","753":"b06a1382"}[chunkId] + ".chunk.js";
};